import React from "react";

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null, eventId: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.eventId) {
      return null;
    }
    return null;
  }

  componentDidCatch(error, errorInfo) {
    // Log component stack for production debugging.
    // eslint-disable-next-line no-console
    console.error("AppErrorBoundary caught error:", error, errorInfo?.componentStack || "");
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: "32px",
            fontFamily: "system-ui, sans-serif",
            minHeight: "100vh",
            display: "grid",
            alignItems: "center",
            justifyItems: "start",
            gap: "14px",
            background: "#f8fafc",
            color: "#0f172a",
          }}
        >
          <h1 style={{ fontSize: "20px", margin: "0", color: "#0f172a" }}>Something went wrong</h1>
          <p style={{ margin: "0", color: "#334155", maxWidth: "680px" }}>
            We hit an app error while loading this page. Refresh to retry. If this keeps happening, share this session id with support.
          </p>
          <p style={{ margin: "0", color: "#0f172a", fontSize: "12px", fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}>
            {this.state.error?.name ? `${this.state.error.name}: ` : ""}
            {this.state.error?.message || "Unexpected runtime error"}
          </p>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" }}>
            <button
              type="button"
              onClick={() => {
                this.setState({ hasError: false, error: null, errorInfo: null });
                window.location.reload();
              }}
              style={{
                border: "1px solid #0f766e",
                background: "#0d9488",
                color: "#ffffff",
                borderRadius: "999px",
                padding: "9px 14px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Refresh page
            </button>
            <button
              type="button"
              onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
              style={{
                border: "1px solid #cbd5e1",
                background: "#fff",
                color: "#0f172a",
                borderRadius: "999px",
                padding: "9px 14px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Retry render
            </button>
          </div>
          <details style={{ marginTop: "4px", color: "#475569", maxWidth: "900px" }}>
            <summary>Technical detail</summary>
            <pre
              style={{
                marginTop: "10px",
                whiteSpace: "pre-wrap",
                background: "#fff",
                border: "1px solid #cbd5f1",
                borderRadius: "10px",
                padding: "10px",
                maxHeight: "240px",
                overflow: "auto",
              }}
            >
              {(this.state.errorInfo?.componentStack || "").trim() || String(this.state.error?.stack || this.state.error || "")}
            </pre>
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}
